import {useMemo} from 'react';
import {SortDirType} from "../../types/common/SortDirType";
import {AdminAccountReportVO} from "../../types/admin/AdminAccountReportVO";
import {useGetRequestAutoAbortPaginated} from "../request/useGetRequestAutoAbortPaginated";
import {accountEditEndpoints} from "../../requests/api-endpoints";

interface UseAdminAccounts {
  page?: string;
  rowsPerPage?: string;
  date?: string;
  sort: string;
  sortDir: SortDirType;
  creationDate?: string | null;
  type?: string | null;
  accountId?: string | null;
  email?: string | null;
  username?: string | null;
  activated?: boolean | null;
}

/**
 * Hook for reactively grabbing data from the SupplierActivitySummaries endpoint.
 * Automatically aborts previous requests and separates pagination info and the data
 **/
const useAdminAccounts = ({
                            page,
                            rowsPerPage,
                            sort,
                            sortDir,
                            creationDate,
                            type,
                            accountId,
                            email,
                            username,
                            activated
                          }: UseAdminAccounts) => {
  const queryParams = useMemo(() => ({
    page: page,
    size: rowsPerPage,
    sortBy: sort,
    sortDir: sortDir,
    creationDate: creationDate || undefined,
    type: type || undefined,
    accountId: accountId || undefined,
    email: email || undefined,
    username: username || undefined,
    activated: activated !== null && activated !== undefined ? activated : undefined,
  }), [creationDate, type, accountId, email, username, activated, page, rowsPerPage, sort, sortDir]);

  const {
    responseContent: accounts,
    pageInfo,
    isLoading,
    error,
    doRequest
  } = useGetRequestAutoAbortPaginated<AdminAccountReportVO[]>({
    requestUrl: accountEditEndpoints.adminAccountReport.getAccountReport,
    queryParams
  })

  return {
    accounts,
    pageInfo,
    isLoading,
    error,
    doRequest
  }
}

export {useAdminAccounts};
